import { CloseOutlined, ScheduleOutlined } from '@ant-design/icons';
import { Button, Modal, Spin, Table, Typography } from 'antd';
import Column from 'antd/es/table/Column';
import { importTimesheetApi } from 'Api/importTimesheet';
import { useEffect, useState } from 'react';
import { toastText } from 'utils/utils';
import styles from './index.module.scss';
import './index.scss';

type Props = {
	isOpen: boolean;
	handleCancel: () => void;
	selectedTimeSheet: any;
};

const AddModal = (props: Props) => {
	const { isOpen, handleCancel, selectedTimeSheet } = props;
	const [timeActivities, setTimeActivities] = useState<any[]>([]);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [totalRecords, setTotalRecords] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(30);
	const [isExportLoading, setIsExportLoading] = useState(false);

	const tableChangeHandler = (pagination: any, filters: any, sorter: any) => {
		setTotalRecords(pagination.total);
		setCurrentPage(pagination.current);
		setPageSize(pagination.pageSize);
	};

	const fetchTimeActivities = async () => {
		const query = {
			timeSheetId: selectedTimeSheet.id, // ✅
			page: currentPage,
			pageSize,
		};
		setIsLoading(true);
		try {
			if (selectedTimeSheet.isImportedTimeSheet) {
				const response = await importTimesheetApi.importTimesheetLogs(
					query
				);

				setTimeActivities(response.data.data);
				setTotalRecords(response.data.total);
			} else {
				toastText('we have disabled this feature as of now.', 'error');
			}
		} catch (error: any) {
			let message =
				error?.response?.data?.message ||
				`Error fetching Monthly Summary`;
			toastText(message, 'error');
		} finally {
			setIsLoading(false);
		}
	};

	const exportPdf = async () => {
		try {
			setIsExportLoading(true);

			toastText('we have disabled this feature as of now.', 'error');
		} catch (err: any) {
			toastText(
				err?.response?.data?.message ||
					'Something went wrong in exporting pdf report',
				'error'
			);
		} finally {
			setIsExportLoading(false);
		}
	};

	useEffect(() => {
		if (selectedTimeSheet) {
			fetchTimeActivities();
		}
	}, [selectedTimeSheet, currentPage, pageSize]);

	return (
		<Modal
			open={isOpen}
			style={{
				minWidth: '1200px',
				zIndex: '99999',
			}}
			closable={false}
			centered={true}
			rootClassName="time-sheet-modal"
			onCancel={handleCancel}
			footer={
				!selectedTimeSheet.isImportedTimeSheet && (
					<div className={styles['modal-footer']}>
						<Button
							type="primary"
							onClick={exportPdf}
							loading={isExportLoading}
							disabled={isLoading || isExportLoading}
						>
							Export PDF
						</Button>
					</div>
				)
			}
			width={800}
		>
			<div className={`${styles['modal']} modal`}>
				<div className={styles['modal-header']}>
					<Typography.Title level={4}>
						<span>
							<ScheduleOutlined
								style={{
									fontSize: '20px',
									marginRight: '10px',
								}}
							/>
							Time Sheets {selectedTimeSheet.timeSheetName}
						</span>
					</Typography.Title>
					<Button
						//className={styles['close-button']}
						icon={<CloseOutlined />}
						onClick={handleCancel}
					/>
				</div>
				<Spin spinning={isLoading}>
					<Table
						dataSource={timeActivities}
						scroll={{ y: 'calc(100vh - 360px)' }}
						rowKey="id"
						pagination={{
							total: totalRecords,
							current: currentPage,
							pageSize: pageSize,
							showSizeChanger: false,
							// onShowSizeChange: pageSizeHandler,
							// pageSizeOptions: [10, 20, 50, 100, 200],
						}}
						onChange={tableChangeHandler}
					>
						<Column
							title="Employee Code"
							dataIndex={
								selectedTimeSheet.isImportedTimeSheet
									? 'employeeId'
									: 'optionalEmployeeId'
							}
							key={
								selectedTimeSheet.isImportedTimeSheet
									? 'employeeId'
									: 'optionalEmployeeId'
							}
							className="bg-white"
						/>
						<Column
							title="Employee Name"
							key="employeeName"
							className="bg-white"
							render={(text, record: any) =>
								`${record.firstName} ${record.lastName}`
							}
						/>
						<Column
							title="Regular Hours"
							dataIndex="totalRegularHours"
							key="totalRegularHours"
							className="bg-white"
						/>
						{selectedTimeSheet.isImportedTimeSheet && (
							<Column
								title="Weekday OT Hours"
								dataIndex="totalWeekdayOTHours"
								key="totalWeekdayOTHours"
								className="bg-white"
							/>
						)}
						{selectedTimeSheet.isImportedTimeSheet && (
							<Column
								title="Double OT Hours"
								dataIndex="totalDoubleOTHours"
								key="totalDoubleOTHours"
								className="bg-white"
							/>
						)}
						{selectedTimeSheet.isImportedTimeSheet && (
							<Column
								title="Shift Difference Hours"
								dataIndex="totalShiftDiffHours"
								key="totalShiftDiffHours"
								className="bg-white"
							/>
						)}

						{/* Regular timesheet columns */}
						{!selectedTimeSheet.isImportedTimeSheet && (
							<Column
								title="Overtime Hours"
								dataIndex="totalOvertimeHours"
								key="totalOvertimeHours"
								className="bg-white"
							/>
						)}
						{!selectedTimeSheet.isImportedTimeSheet && (
							<Column
								title="Total Hours"
								dataIndex="totalHours"
								key="totalHours"
								className="bg-white"
							/>
						)}
						{!selectedTimeSheet.isImportedTimeSheet && (
							<Column
								title="Shift Time Difference"
								dataIndex="totalTimeShiftHours"
								key="totalTimeShiftHours"
								className="bg-white"
							/>
						)}
					</Table>
				</Spin>
			</div>
		</Modal>
	);
};

export default AddModal;
